// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanDeleteAsset } from "./hook";

export type CanDeleteAssetProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanDeleteAsset({
  children,
  fallback,
  scope,
}: CanDeleteAssetProps) {
  const canDoAction = useCanDeleteAsset(scope);
  return <>{canDoAction ? children : fallback}</>;
}
